import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store'
import CONSTANTS from '@/constants'
Vue.use(VueRouter);

//Here we set the type of the project as 'playbook' or 'snapsheet'
function setTypeOfProject(type) {
  store.commit('project/SET_TYPE_OF_PROJECT', type)
}
function setCreateMode() {
  store.commit('project/SET_PROJECT_MODE', CONSTANTS.PROJECT_MODES.CREATE)
}

const routes = [

  //CREATE
  {
    path: '/snapsheets/create',
    name: 'CreateSnapsheet',
    component: () => import('../../views/projects/Project'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('snapsheet')
      setCreateMode()
      next()
    },
    props: { typeOfProject: 'snapsheet' },
    meta: { title: 'Create Snapsheet' }
  },

  {
    path: '/catalogs/create',
    name: 'CreateCatalog',
    component: () => import('../../views/projects/Project'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('catalog')
      setCreateMode()
      next()
    },
    props: { typeOfProject: 'catalog' },
    meta: { title: 'Create Catalog' }
  },

  // PREVIEWS
  {
    path: '/snapsheets/:dealer_code/:project_id',
    name: 'Snapsheet',
    component: () => import('../../views/projects/Project'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('snapsheet')
      next()
    },
    props: { typeOfProject: 'snapsheet' },
    meta: { title: 'Snapsheet Project' }
  },

  {
    path: '/catalogs/:dealer_code/:project_id',
    name: 'Catalog',
    component: () => import('../../views/projects/Project'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('catalog')
      next()
    },
    props: { typeOfProject: 'catalog' },
    meta: { title: 'Catalog Project' }
  },

  // SHOWROOM
  {
    path: '/showrooms/:dealer_code',
    name: 'Showroom',
    component: () => import('../../views/projects/Showroom/Home'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('showroom')
      next()
    },
    props: { typeOfProject: 'showroom' },
    meta: { title: 'Showroom Project' }
  },

  {
    path: '/showrooms/:dealer_code/catalogue',
    name: 'Showroom Catalogue',
    component: () => import('../../views/projects/Showroom/Catalogue'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('showroom')
      next()
    },
    props: { typeOfProject: 'showroom' },
    meta: { title: 'Showroom Project' }
  },

  {
    path: '/showrooms/:dealer_code/product',
    name: 'Showroom Product',
    component: () => import('../../views/projects/Showroom/SingleProduct'),
    props: { typeOfProject: 'showroom' },
    meta: { title: 'Showroom Project' }
  },

  //ACTIVE PRODUCT

  {
    path: '/snapsheets/:dealer_code/:project_id/product/:product_id',
    name: 'Customize Your Product',
    component: () => import('../../views/projects/ActiveProductPage'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('snapsheet')
      next()
    },
    props: { typeOfProject: 'snapsheet' },
    meta: { title: 'Customize Your Product' }
  },

  {
    path: '/catalogs/:dealer_code/:project_id/product/:product_id',
    name: 'Customize Your Product',
    component: () => import('../../views/projects/ActiveProductPage'),
    props: { typeOfProject: 'catalog' },
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('catalog')
      next()
    },
    meta: { title: 'Customize Your Product' }
  },

  {
    path: '/showrooms/:dealer_code/product/:product_id',
    name: 'Customize Your Product',
    component: () => import('../../views/projects/ActiveProductPage'),
    props: { typeOfProject: 'showroom' },
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('showroom')
      next()
    },
    meta: { title: 'Customize Your Product' }
  },

  // LOCKERS
  {
    path: '/snapsheets/:dealer_code/:project_id/locker',
    name: 'Snapsheet Locker',
    component: () => import('../../views/projects/Locker'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('snapsheet')
      next()
    },
    props: { typeOfProject: 'snapsheet' },
    meta: { title: 'Snapsheet Locker' }
  },

  {
    path: '/catalogs/:dealer_code/:project_id/locker',
    name: 'Catalog Locker',
    component: () => import('../../views/projects/Locker'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('catalog')
      next()
    },
    props: { typeOfProject: 'catalog' },
    meta: { title: 'Catalog Locker' }
  },

  {
    path: '/showrooms/:dealer_code/locker',
    name: 'Showroom Locker',
    component: () => import('../../views/projects/Locker'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('showroom')
      next()
    },
    props: { typeOfProject: 'showroom' },
    meta: { title: 'Showroom Locker' }
  },

  //Roster
  {
    path: '/snapsheets/:dealer_code/:project_id/roster',
    name: 'Roster',
    component: () => import('../../views/projects/Roster'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('snapsheet')
      next()
    },
    props: { typeOfProject: 'snapsheet' },
    meta: { title: 'Roster' }
  },
  {
    path: '/catalogs/:dealer_code/:project_id/roster',
    name: 'Roster',
    component: () => import('../../views/projects/Roster'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('catalog')
      next()
    },
    props: { typeOfProject: 'catalog' },
    meta: { title: 'Roster' }
  },
  {
    path: '/showrooms/:dealer_code/roster',
    name: 'Roster',
    component: () => import('../../views/projects/Roster'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('showroom')
      next()
    },
    props: { typeOfProject: 'showroom' },
    meta: { title: 'Roster' }
  },

  //Sizes Selection
  {
    path: '/snapsheets/:dealer_code/:project_id/sizes-selection',
    name: 'SizesSelection',
    component: () => import('../../views/projects/SizesSelection'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('snapsheet')
      next()
    },
    props: { typeOfProject: 'snapsheet' },
    meta: { title: 'Sizes Selection' }
  },
  {
    path: '/catalogs/:dealer_code/:project_id/sizes-selection',
    name: 'SizesSelection',
    component: () => import('../../views/projects/SizesSelection'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('catalog')
      next()
    },
    props: { typeOfProject: 'catalog' },
    meta: { title: 'Sizes Selection' }
  },
  {
    path: '/showrooms/:dealer_code/sizes-selection',
    name: 'SizesSelection',
    component: () => import('../../views/projects/SizesSelection'),
    beforeEnter: (_to, _from, next) => {
      setTypeOfProject('showroom')
      next()
    },
    props: { typeOfProject: 'showroom' },
    meta: { title: 'Sizes Selection' }
  },

];



export default routes;
